import { TranslationInvoiceMessages, InvoiceMessages } from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationInvoiceMessages = {
  [InvoiceMessages.activeText]: "Text"
};
